export const DataMutationMyBag_ItemRemove_QueryKey = {
  mybagItemRemove: (): string => {
    const queryKey = "data-mutation-mybag-item-remove";
    return queryKey;
  },
};
